import { useQuery } from "@tanstack/react-query";

import getUsersByName from "../api/getUsersByName";

const useGetUsersByName = (userName: string) => {
  const {
    data: getUsersByNameData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["getUsersByName", userName],
    queryFn: () => getUsersByName(userName),
    enabled: !!userName.trim(),
    refetchOnWindowFocus: false,
  });

  return { getUsersByNameData, isLoading, isError, error };
};

export default useGetUsersByName;
